export class UserSearchCriteria {
  nameOrEmail: string;
  billingAccount: any;
  roles: any;

  constructor(userChoicesActiveFilters) {
    this.nameOrEmail = userChoicesActiveFilters.nameOrEmail;
    this.roles = userChoicesActiveFilters.roles;
    this.billingAccount = userChoicesActiveFilters.billingAccount;
  }
}

